import { render, staticRenderFns } from "./GreenButtonDowload.vue?vue&type=template&id=50b04012"
import script from "./GreenButtonDowload.vue?vue&type=script&lang=js"
export * from "./GreenButtonDowload.vue?vue&type=script&lang=js"
import style0 from "./GreenButtonDowload.vue?vue&type=style&index=0&id=50b04012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports